import { useEffect, useState } from 'react';
import { getStorageItem, subscribeToStorageItem, unSubscribeToStorageItem } from 'app/sharedServices/storage/storage';
import { AgencyBranding, getAgencyBranding } from 'app/config/agencyBranding';
import { CurrentServiceInfo } from 'app/routes';

export type ResolvedAgencyBranding = {
  agencyName?: string;
  branding?: AgencyBranding;
};

const resolveBranding = (serviceInfo?: CurrentServiceInfo): ResolvedAgencyBranding => {
  const agencyName = serviceInfo?.agencyName;

  return {
    agencyName,
    branding: getAgencyBranding(agencyName),
  };
};

const useAgencyBranding = (): ResolvedAgencyBranding => {
  const [resolved, setResolved] = useState<ResolvedAgencyBranding>(() =>
    resolveBranding(getStorageItem('currentServiceInfo', 'session')),
  );

  useEffect(() => {
    // Re-read on mount in case currentServiceInfo was written before this hook mounted.
    setResolved(resolveBranding(getStorageItem('currentServiceInfo', 'session')));

    const onChange = (serviceInfo: CurrentServiceInfo) => {
      setResolved(resolveBranding(serviceInfo));
    };
    subscribeToStorageItem('currentServiceInfo', onChange);
    return () => unSubscribeToStorageItem('currentServiceInfo', onChange);
  }, []);

  return resolved;
};

export default useAgencyBranding;
